import type { ResourceTypeString } from '@ctw/shared/api/fhir/types';
import { fqsRequest } from '@ctw/shared/api/fqs/client';
import type { useTelemetry } from '@ctw/shared/context/telemetry/telemetry-boundary';
import type { Provenance } from 'fhir/r4';
import { type GraphQLClient, gql } from 'graphql-request';

export async function searchProvenancesFQS(
  telemetry: ReturnType<typeof useTelemetry>,
  graphqlClient: GraphQLClient,
  resourceType: ResourceTypeString,
  targets: Array<string>,
) {
  const targetIds = targets.map((target) => target.replace(`${resourceType}/`, ''));

  const { data } = await fqsRequest<ProvenanceResponse>(
    telemetry,
    graphqlClient,
    provenanceQueries(resourceType, targetIds),
    {},
  );

  return Object.values(data).reduce(
    (acc, val) => {
      acc.push(...val.ProvenanceList);
      return acc;
    },
    [] as Array<Provenance>,
  );
}

type ProvenanceResponse = {
  [key: string]: {
    ProvenanceList: Array<Provenance>;
  };
};

function provenanceQueries(resourceType: ResourceTypeString, targetIds: Array<string>) {
  return gql`
    query GetProvenances {
      ${targetIds.map((id, index) => provenanceQuery(resourceType, id, index)).join('\n')}
    }
  `;
}

function provenanceQuery(resourceType: ResourceTypeString, targetId: string, index: number) {
  return `
    provenance${index}: ${resourceType}(id: "${targetId}") {
      ProvenanceList(_reference: "target") {
        id
        meta {
          tag {
            system
            code
          }
        }
        target {
          reference
        }
        entity {
          role
          what {
            reference
          }
        }
      }
    }
  `;
}
